import type { Day } from "../utils/days.js";
import type { Address } from "./Address.js";
import { Country } from "./Country.js";
import { Locale, type LocalizedString } from "./Locale.js";

export interface FathersPlaceOpeningHoursSpecification {
	dayOfWeek: readonly Day[];
	opens: string;
	closes: string;
}

export interface FathersPlace extends Omit<Address, "firstName" | "lastName"> {
	name: LocalizedString;
	geo: { latitude: number; longitude: number };
	mapUrl: string;
	openingHours: LocalizedString[];
	openingHoursSpecification: FathersPlaceOpeningHoursSpecification[];
}

export const fathersRoastery: FathersPlace = {
	name: { [Locale.cs]: "Pražírna Ostrava", [Locale.en]: "Roastery Ostrava" },
	street: "Mitrovická 128/66",
	zip: "724 00",
	city: "Ostrava",
	country: Country.Czechia,
	geo: { latitude: 49.7630709, longitude: 18.2154091 },
	mapUrl: "https://maps.app.goo.gl/ipBns6AQqruvtXyr8",
	openingHours: [{ [Locale.cs]: "po telefonické domluvě", [Locale.en]: "by phone appointment" }],
	openingHoursSpecification: [],
};

export const fathersCoffeeStore: FathersPlace = {
	name: { [Locale.cs]: "Coffee Store Praha", [Locale.en]: "Coffee Store Prague" },
	street: "Bubenečská 43",
	zip: "160 00",
	city: "Praha 6",
	country: Country.Czechia,
	geo: { latitude: 50.1019795, longitude: 14.4047818 },
	mapUrl: "https://www.google.com/maps/search/?api=1&query=Bubene%C4%8Dsk%C3%A1%2043%2C%20160%2000%20Praha%206",
	openingHours: [
		{ [Locale.cs]: "pondělí až pátek /  10–19 h", [Locale.en]: "Mon–Fri /  10am–7pm" },
		{ [Locale.cs]: "sobota /  8–14 h", [Locale.en]: "Sat /  8am–2pm" },
	],
	openingHoursSpecification: [
		{ dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "10:00", closes: "19:00" },
		{ dayOfWeek: ["Saturday"], opens: "08:00", closes: "14:00" },
	],
};

export const fathersPlaces: readonly FathersPlace[] = [fathersRoastery, fathersCoffeeStore];
